import { __decorate } from "tslib";
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { WebsiteThemeService } from '../../../../services/website-theme.service';
import { SharedHttp } from '../../../../services/http-client.service';
let GoToBlinkingComponent = class GoToBlinkingComponent {
    constructor(httpClient, themeService, sanitizer) {
        this.httpClient = httpClient;
        this.themeService = themeService;
        this.sanitizer = sanitizer;
        this.borderRadiusLarger = '';
        this.blinkingAvailable = new EventEmitter();
        this.blinkingUrl = new EventEmitter();
        this.themeService.getTheme().subscribe((data) => {
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
        });
    }
    ngOnInit() {
    }
    goToBlinking() {
        this.httpClient.post('blinking/initiateProcess', { languageCode: this.lang }).subscribe((data) => {
            this.blinkingUrl.emit(data['url']);
        }, (error) => {
            this.blinkingAvailable.emit(false);
        });
    }
};
GoToBlinkingComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: WebsiteThemeService },
    { type: DomSanitizer }
];
__decorate([
    Input()
], GoToBlinkingComponent.prototype, "lang", void 0);
__decorate([
    Output()
], GoToBlinkingComponent.prototype, "blinkingAvailable", void 0);
__decorate([
    Output()
], GoToBlinkingComponent.prototype, "blinkingUrl", void 0);
GoToBlinkingComponent = __decorate([
    Component({
        selector: 'ecd-go-to-blinking',
        template: __importDefault(require("./go-to-blinking.component.html")).default,
    })
], GoToBlinkingComponent);
export { GoToBlinkingComponent };
